module.exports = __webpack_public_path__ + "static/img/internet-banking-vector-icon.bca2042.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/internet-banking-vector-icon.jpg
// module id = lGhV
// module chunks = 3